module.exports = __webpack_public_path__ + "static/media/picture.27cf32b2.svg";